UC = UC || {};
UC.timesheetComponent = UC.timesheetComponent || {};

UC.timesheetComponent.TimesheetInvoice = Backbone.Model.extend({
  idAttribute: '_id'
});
